module.exports = __webpack_public_path__ + "static/media/regelwerk_header.5ea0878d.jpg";


//////////////////
// WEBPACK FOOTER
// /src/images/regelwerk_header.jpg
// module id = 1607
// module chunks = 0